module.exports = __webpack_public_path__ + "img/compact.7da12bcf.png";